import ImageLightbox from "./ImageLightbox.vue";

bootVue('.vue-image-lightbox', ImageLightbox);
